import FieldsCollection from "../../fields3/collection/base/fields-collection"
import Task from "../task/task"
import FieldConfig from "../../fields3/proto/field-config"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string"
import FieldUser from "../../fields3/generic/user/user"
import FieldDate from "../../fields3/generic/datetime/date/date"

export default class ReminderFields extends FieldsCollection {
    constructor(task?: Task) {

        const taskUsers = _.map(task?.users, taskUser => {
            const user = gd.session.users.get(taskUser.userId)!
            return {
                value   : user.id,
                label   : user.name,
            }
        })

        const fieldsConfig : FieldConfig[] = [
            {
                fieldId         : 'title',
                type            : FieldType.STRING,
                label           : 'Name'
            },
            {
                fieldId         : 'userId',
                type            : FieldType.USER,
                isRequired      : true,
                noValueOption   : false,
                options         : taskUsers,
                label           : 'User'
            },
            {
                fieldId         : 'date',
                type            : FieldType.DATE,
                minDate         : moment(),
                label           : 'Date',
                placeholder     : 'Date'
            }
        ]

        super(fieldsConfig)
    }

    get title()     : FieldString {return this.get('title') as FieldString}
    get userId()    : FieldUser {return this.get('userId') as FieldUser}
    get date()      : FieldDate {return this.get('date') as FieldDate}
}